import { fetchJSONFactory } from "@/utils/fetch-json";

const fetchJSON = fetchJSONFactory(import.meta.env.VITE_DOCUMENTS_API);

type MembershipAgreementSignLinkResponse = {
  link: string;
};

export const getMembershipAgreementSignLink = async (membershipId: number) => {
  return fetchJSON<MembershipAgreementSignLinkResponse>(
    "users/membership-agreement-sign-link",
    {
      params: {
        membershipId: membershipId.toString(),
      },
    },
  );
};
